<template>
    <div>
       <basic-container>

           <el-form ref="searchFormRef" :model="selectForm" label-suffix=':' label-width="100px"  v-show="searchBoxFlag">
                <el-row :gutter="24">
                      <el-col :span="6">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select v-model="selectForm.projectId" placeholder="项目名称" style="width:100%" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="设备编号" prop="code" >
                              <el-input placeholder="设备编号" maxlength="20" show-word-limit clearable v-model="selectForm.code"></el-input>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="设备名称" prop="name" >
                              <el-input placeholder="设备名称" maxlength="20" show-word-limit  clearable v-model="selectForm.deviceName" ></el-input>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="设备类型" prop="objectType">
                              <el-select
                                ref="typeIdSelect"
                                :value="selectForm.typeName"
                                placeholder="设备类型"
                                style="width: 100%;"
                                clearable
                                :disabled="!objectTypeFlag"
                                @clear='objectTypeClear()' 
                              >
                              
                                    <!-- :load="typeLazyLoadTree" lazy-->
                                <el-option :value="selectForm.typeId" show-all-levels :label="selectForm.typeName">
                                  <el-tree
                                    node-key="id"
                                    :data="treeFormData"
                                    :props="treeProps"
                                    
                                    @node-click="typeNodeTreeClick"
                                  >
                                  </el-tree>
                                </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                       <el-col :span="6">
                          <el-form-item label="所属部门" prop="deptId">
                              <el-select  
                              clearable 
                              @clear="deptClear"
                                  :disabled="!deptIdFlag"       
                                  :value="selectForm.deptName"
                                  placeholder="所属部门"
                                  style="width: 100%;"
                                  filterable 
                                  @focus="showDetpTree=true"
                                  >
                                  <el-option v-show="showDetpTree" :value="selectForm.deptName" show-all-levels :label="selectForm.deptName">
                                      <el-tree
                                      node-key="id"
                                      :data="treeFormDeptData"
                                      :props="treeDeptProps"
                                          @node-click="handleDeptNodeClick"
                                      >
                                      </el-tree>
                                  </el-option>
                                  </el-select>
                              </el-form-item>
                      </el-col>
                      <el-col :span="12" style="height:54px">
                          <el-form-item label="维修日期" prop="name" >
                              <el-date-picker
                                  style="width: 100%"
                                  clearable
                                  v-model="selectForm.timeRange"
                                  value-format="yyyy-MM-dd"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  >
                              </el-date-picker>
                          </el-form-item>
                      </el-col>
                      
                      <el-col :span="6">
                          <el-form-item label="维修金额">
                              <div style="display:flex;">
                                  <el-input  clearable  placeholder="维修金额"  v-model="selectForm.startAmount"  maxlength="12"
                                  />-
                                      <el-input clearable placeholder="维修金额" v-model="selectForm.endAmount" maxlength="12" />
                              </div>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="维修人">
                              <el-input placeholder="维修人" maxlength="20" show-word-limit  clearable v-model="selectForm.realRepairManName" ></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="18">
                          <div style="float:right">
                              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small"> 搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete" size="small"> 清空 </el-button>
                          </div>
                      </el-col>
                </el-row>
          </el-form>
            <avue-crud
            v-if="showCrudFlag"
            :option="option"
            :table-loading="loading"
            :data="deviceMaintenanceRecordList"
            :page.sync="page"
            v-model="selectForm"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
            @size-change="sizeChange"
            @refresh-change="onLoad">
             <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
                :refOption="$refs.crud"
                ></searchFromShow>
            </template>
             <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord"> 新 增</el-button>
            <exportData :moduleType="400" @exportExcel="exportExcel"></exportData>
            <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="delConstractInvoice">删除</el-button> -->
            </template>
             <!-- <template slot-scope="scope" slot="projectId">
               {{getProjectName(scope.row.projectId)}}
             </template> -->
              <template slot-scope="scope" slot="serviceHour">
               
               <div class="time"><span>{{getHourTime(scope.row.serviceHour)}}</span></div>
             </template>
             <template slot-scope="scope" slot="amount">
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.amount)  }}</span></div>
            </template>
            <template slot-scope="scope" slot="menu">
            <el-button
                type="text"
                size="small"
                icon="el-icon-tickets"
                @click="checkRecord(scope.row.id)"
                >查看
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                v-if='scope.row.lifecycleIndex!=3&&scope.row.lifecycleIndex!=5'
                @click="editRecord(scope.row.id)"
                >编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                v-if='scope.row.lifecycleIndex!=3&&scope.row.lifecycleIndex!=5'
                @click="removeRecord(scope.row.id)"
                >删除
            </el-button>
            </template>
        </avue-crud>
        <!-- 新增设备维保记录对话框 -->
        
        <hr-dialog
           :title="dialogTitle"
          v-if="addOrEditOrWatchFlag"
          :visible.sync="addOrEditOrWatchFlag"
         
          width="80%"
         
          :handleClose="handleClose"
        >
          <template slot="body">
            
              <recordOperate :projectList='projectList' :form='form' :isEdit='isEdit' @cancelOperate="cancelOperate" @submitOver='submitOver'></recordOperate>
          </template>
        </hr-dialog>
       </basic-container>
    </div>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { treeByProjectDeptId } from '@/api/crmedical/device/device';
import { getDeviceMaintennanceRecordList,addDeviceMaintennanceRecord,getDeviceMaintennanceRecordDetail,removeDeviceMaintennanceRecord } from '@/api/crmedical/device/deviceMaintenanceRecord';
import { tree } from '@/api/crmedical/device/devicetype';
import recordOperate from '@/components/device/deviceMaintenanceRecord/maintenanceRecoderAdd.vue'
import searchFromShow from '@/components/search-form-show/index'
 import {getToken} from '@/util/auth';
 import exportData from "@/components/exportData/exportDataSimple";
export default {
  components:{recordOperate,searchFromShow,exportData},
    data() {
    return {
          showDetpTree:false,
        treeFormDeptData: [], //所属部门
      searchBoxFlag:true,
        searchHeight:'',
      showCrudFlag:false,
      recordEdit:false,
      addOrEditOrWatchFlag:false,
      dialogTitle:'新增设备维保记录',
      selectForm: {
        projectId: '',
        typeName:'',
        typeId:'',
        startTime:'',
        endTime :'',
        startAmount:'',
        endAmount:'',
        timeRange:[],
        code: '',
        deviceName:'',
        realRepairManName:'',
        deptId:'',
        deptName:''
      },
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      projectList:[],
      deviceMaintenanceRecordList:[],//设备维修记录list
      option:{
        index: true,
        selection: true,
        // reserveSelection:true,
        indexLabel: '序号',
        page: true,
        align: 'left',
        menuAlign: 'center',
        addBtn:false,
        editBtn: false,
        delBtn: false,
        border:true,
        height:'auto',

        column: [
          {
            label: '项目名称',
            prop: 'projectName',
          },
          
          {
            label: '设备类型',
            prop: 'deviceType',
          },
          {
            label: '设备编号',
            prop: 'code',
          },
          {
            label: '设备名称',
            prop: 'deviceName',
          },
         
          {
            label: '所属部门',
            prop: 'deptName',
          },
          {
            label: '存放位置',
            prop: 'areaName',
          },
          {
            label: '维修人',
            prop: 'realRepairManName',
          },
          {
            label: '维修时间',
            prop: 'realRepairTime',
            
          },
          {
            label: '维修金额',
            prop: 'amount',
            slot:true
          },
          {
            label: '维修工时',
            prop: 'serviceHour',
            slot:true
          },
          {
            label:'工单编号',
            prop:'orderCode',
            width:'160',
          },
          {
            label: '备注',
            prop: 'description',
            hide:true
          },
          
        ]
      },
       page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading:false,
      treeFormData: [], //设备类型
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'children',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'title',
      },
      form:{
         projectId: '',
         attachList:[]
      },
      objectTypeFlag:false,//设备类型下拉框使用状态,
      recordIds:[],
       exportForm:{},
       deptIdFlag:false
    };
  },
  created(){
      this.initData()
      
  },
  mounted(){
      this.calcHeight()
  },
  methods:{
    deptClear(){
      this.selectForm.deptName=""
      this.selectForm.deptId=""
    },
       handleDeptNodeClick(node) {
      //  if (parseInt(node.nodeType) == 1) {
      //     // this.$message.error();
      //     return;
      //   }
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.deptName = nodeTitle;
      this.selectForm.deptId = nodeId;
      console.log(node);
    },
    treeByProjectDeptId(value) {
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.treeFormDeptData = res.data;
        this.deptIdFlag = true
      });
    },
        selectionChange(val){
      this.recordIds = []
      val.forEach(element => {
        this.recordIds.push(element.id)
      });
    },
     exportExcel(data) {

        let saveIds = data.exportExcelSelectionRadio=='1'?'':this.recordIds;
      
      if(saveIds.length==0 && data.exportExcelSelectionRadio == 2){
              this.$message({
                      message:'请选择需要导出的数据！',
                      type: 'warning'
              });
              return;
      }
        this.$confirm("是否导出设备维修数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出数据
            let projectId =this.exportForm.projectId ?this.exportForm.projectId:this.selectForm.projectId;
            let params = this.tool.formateObjToParamStr(this.exportForm)
            if(data.exportExcelSelectionRadio == 2){
              this.tool.downloadFile(`/api/v4ward/repair/task/device/repairExport?${
                  this.website.tokenHeader
                }=${getToken()}&projectId=${projectId}&ids=${saveIds}`)
              
            }else{
              // 将条件参数拼接为路由传参格式
             
              // 
              this.tool.downloadFile(
                `/api/v4ward/repair/task/device/repairExport?${
                  this.website.tokenHeader
                }=${getToken()}&ids=&`+ params,"abc.xlsx",'xlsx/xls'
                )
             
            }

          });
      },
    calcHeight(){
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight+30
      this.option.height = this.bodyHeight - this.searchHeight-285 
    },
    getHourTime(time){
      let hour = parseInt(time/60);
      let minute = parseInt(time%60)
      let str = ''
      if(hour>0){
        str = hour + "小时" +minute + "分钟"
        return  str
      }else{
        str = minute + "分钟"
        return str
      }
    },
    getProjectName(id){
      let str
      try{
        this.projectList.forEach(item =>{
        if(item.id == id){
         str= item.name
          throw new Error()
        }
      })
      }catch(e){
        return str
      }
    },
        handleClose(){
            this.form={
            projectId: '',
            attachList:[]
          }
           this.addOrEditOrWatchFlag = false
        },
        //新增编辑取消
        cancelOperate(){
          this.addOrEditOrWatchFlag = false
        },
        //新增，编辑结束
        submitOver(){
          this.addOrEditOrWatchFlag = false
          this.onLoad()
        },
        removeRecord(id){
          this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {    
             removeDeviceMaintennanceRecord(id).then(()=>{
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.onLoad()
            })
        })
            
        },
        editRecord(id){
          getDeviceMaintennanceRecordDetail(id).then(({data})=>{
            this.isEdit = true
            this.form = data
            this.dialogTitle = "编辑"
            this.addOrEditOrWatchFlag = true
            
          })
        },
        checkRecord(id){
          getDeviceMaintennanceRecordDetail(id).then(({data})=>{
            this.isEdit = false
            this.form = data
            this.$set(this.form,'serviceHour',data.serviceHour)
            this.dialogTitle = "查看"
            this.addOrEditOrWatchFlag = true
          })
        },
        //新增
        addRecord(){
          this.form = {
            projectId: '',
            attachList:[]
          }
          this.dialogTitle = "新增"
          this.isEdit = true
          this.addOrEditOrWatchFlag = true
          this.form.projectId = this.selectForm.projectId
        },
        //重置搜索条件
        searchClear(){
          
          this.selectForm.typeName=""
          this.selectForm.typeId=""
          this.selectForm.startTime=""
          this.selectForm.endTime=""
          this.selectForm.startAmount=""
          this.selectForm.endAmount=""
          this.selectForm.timeRange=""
          this.selectForm.code=[]
          this.selectForm.deviceName="",
          this.selectForm.realRepairManName = ''
          this.deptClear()
        },
        //搜索
        searchRecord(){
           this.page.currentPage = 1
          let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
          if ((this.selectForm.startAmount==''&&this.selectForm.endAmount=='')||(reg.test(this.selectForm.startAmount)&&reg.test(this.selectForm.endAmount))) {
            if(this.selectForm.startAmount>this.selectForm.endAmount){
              //大金额在后面
              let transfromNum = this.selectForm.endAmount
              this.selectForm.endAmount = this.selectForm.startAmount
              this.selectForm.startAmount = transfromNum
            }
            console.log(this.selectForm.timeRange)
            if(this.selectForm.timeRange&&this.selectForm.timeRange.length>0){
                this.selectForm.startTime = this.dayjs(this.selectForm.timeRange[0]).format('YYYY-MM-DD 00:00:00')
                this.selectForm.endTime = this.dayjs(this.selectForm.timeRange[1]).format('YYYY-MM-DD 23:59:59') 
            }else{
                this.selectForm.timeRange = []
                this.selectForm.startTime = ''
                  this.selectForm.endTime = ''
            }
             this.onLoad()
          } else {
            let sum = Number(this.selectForm.startAmount)  + Number(this.selectForm.endAmount) 
            if(sum == this.selectForm.startAmount||sum == this.selectForm.endAmount){
              this.$message.error('请输入一个金额范围');
            }else{
              this.$message.error('金额格式不正确，请输入小数点前9位，后2位');
            }
          }
         
        },
        initData(){
          getProjectList().then((res) => {
            this.projectList = res.data;
            if (this.projectList.length > 0) {
                this.$set(this.selectForm, 'projectId', this.projectList[0].id);
                this.selectFormDeviceSelect(this.selectForm.projectId)
                this.treeByProjectDeptId(this.selectForm.projectId);
                this.onLoad()
                this.showCrudFlag = true;
            }
          });
        },
        sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        currentChange(currentPage) {
            this.page.currentPage = currentPage;
        },
        onLoad(page) {
            page = page || this.page;
            this.loading = true;
             this.exportForm = Object.assign({},this.selectForm)
            getDeviceMaintennanceRecordList(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, this.selectForm)).then(({data})=>{
                this.deviceMaintenanceRecordList = data.records
                this.page.total = data.total
                this.loading = false;
        })
      },
      selectFormDeviceSelect(value) {

        tree({ id: 0, projectId: value, objectType: 1 }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          this.treeFormData = data;
          this.objectTypeFlag = true
        });
      },
      typeLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        tree({ id: id, projectId: this.selectForm.projectId, objectType: 1 }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          } else {
            data = [];
          }
          console.log(this.deviceMaintenanceRecordList)
          resolve(data);
        });
      },
      typeNodeTreeClick(node) {
        console.log(node);
        let nodeId = node.id;
        let nodeTitle = node.title;
        this.selectForm.typeName = nodeTitle;
        this.selectForm.typeId = nodeId;
        this.$refs.typeIdSelect.blur();
          this.$forceUpdate();
        console.log(this.deviceMaintenanceRecordList)
      },
      //项目id切换
      projectIdChange(val){
        this.objectTypeFlag = false
        console.log("@@@@@@@@@@")
        this.selectFormDeviceSelect(val)
        this.deptClear()
         this.treeByProjectDeptId(this.selectForm.projectId);
      },
      objectTypeClear(){
        this.selectForm.typeName = '';
        this.selectForm.typeId = '';
      }
  }
}
</script>

<style scoped>
  ::v-deep .avue-crud__right {
  display: flex;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
.time{
  text-align: center
}
::v-deep .el-col-8{
  height: 54px;
}
</style>
